var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "url(#pattern0_4_48)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4_48",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4_48",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4_48",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAA/5JREFUeAHtXT1uE0EYjUQDFIgGIWpEjzgENzAIOINlz/fNFFS4oUGCBo4QCpBAnCKAlDIngAqJAggUNCQakciWo/h5vW9Wu54XaZW1/Xa+b96P1+tEszs7+hEDYkAMiAExIAbEgBgQA2JADAyAgel0ejXG+DCE8MLMXscY39aw9U6a2Wx22d2fmtkfdz+qbeuVINPp9Ia779cmwuJ8eyNICOGSu39ebK7G/d4Ikt+mahRgec69ECSfwGs9Z/RSEHd/tNxYrY97kZD80bZWAZbn3QtB8nXGcmOLj0MIX2u4Bslz7IUguZFFAZb3e9NoL9jqoAkJ0gHJTUpIkCZsdYCVIB2Q3KSEBGnCVgdYCdIByU1KSJAmbHWAlSAdkNykRAlBxuPxtRjjY3f/aGbflq9thvrYzP7mC+UQwjt3fzAajS404XotLFsQdx+b2a+hkt6w74OU0p21iF4XxBTEzF42nNDg/yqZvylPKd1dl2+IYwmSk1GbGKfzNbMfKaVbkOx1AAxB8jnD3X+eNljjbzP7sA7fEMMQ5OQEPvi3n7ZGSindhIQjAEMQd99rO5ktOX6C+IavkwT5viWEtk35K0g4ApAE+bdKkBjjczMbDX3L11Wr5unubxDf8HWSICudlYWAjQwAwOAKTpNRBLjmSIJAGeYACTLnAu0xuEI1dhhFlJD//weduYSEI4AEQQzNX2dwNR/tnD1GESVECTnHXmWfZpgXdsgoooQoIdBoJQAM88K+GEWUECUEGq0EgGFe2BejiBKihECjlQAwzAv7YhRRQpQQaLQSAIZ5YV+MIkqIEgKNVgLAMC/si1FECVFCoNFKABjmhX0xiighSgg0WgkAw7ywL0YRJUQJgUYrAWCYF/bFKKKEKCHQaCUADPPCvhhFlBAlBBqtBIBhXtgXo4gSooRAo5UAMMwL+2IUUUKUEGi0EgCGeWFfjCJKiBICjVYCwDAv7ItRRAlRQqDRSgAY5oV9MYooIUoINFoJAMO8sC9GESVECYFGKwFgmBf2xSiihCgh0GglAAzzlujrzJhKCDEhZ9jd4AkJIkE2sE37Q/SW1Z5D6ggShEpn+8EkSHsOqSNIECqd7QeTIO05pI4wGEHyis/go+9enszQt7yqNZjnLtUBmw7m7l9AoytXnNuiY59tyiH1ODN7v0WkbmyeGOM9KrGbDpYXppcgfjgej69syiH1uHyXAHc/qFkUM3tCJbXtYCml22b2u1JR9vMNnttySD8+3yUgL0xfkyghhE+TyeQ6nUzWgPkuAXlh+gpEOYwxzmaz2UUWd0XHyQvTxxin+Z4iQ7/+OO3f3XdPVum+35sTeFEVNbgYEANiQAyIATEgBsSAGBAD28DAMe2q9a/Y1KerAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.428a130dd516cb426bc4ff923f03c4a1.svg";
export { ForwardRef as ReactComponent };